import React from 'react';
import { TrashIcon } from '@heroicons/react/outline';
import AlertConfirmModal from './AlertConfirmModal';

const DeleteConfirmModal = ({ 
  isOpen, 
  onClose, 
  onConfirm,
  itemType = 'الدورة',  // نوع العنصر: الدورة، القسم، الدرس، إلخ
  itemTitle,           // عنوان العنصر
  customMessage        // نص مخصص (اختياري)
}) => {
  return (
    <AlertConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      icon={TrashIcon}
      iconColorClass="text-red-500"
      title="تأكيد الحذف"
      message={customMessage || `هل أنت متأكد من حذف ${itemType}`}
      details={itemTitle}
      note="لن يمكن التراجع عن هذا الإجراء بعد التأكيد"
      confirmText="تأكيد الحذف"
      cancelText="إلغاء"
      confirmButtonClass="bg-red-600 hover:bg-red-700 dark:bg-red-500 dark:hover:bg-red-600"
      noteClass="text-red-600 dark:text-red-400"
    />
  );
};

export default DeleteConfirmModal;
